<template>
  <v-navigation-drawer
    v-model="toggleVal"
    fixed
    app
  >
    <v-toolbar
      flat
      dark
      :color="$root.themeColor"
      class="toolbar"
    >

      <router-link :to="{ name: 'Main' }">
        <img
          src="logo2.png"
          width="65px"
        >
      </router-link>

    </v-toolbar>

    <div>
      <v-list dense>
        <template v-for="(item, index) in menuItems">
          <v-list-tile
            v-if="item.childrens==null"
            :class="[{'activeBox': selectedIndex === index}, null ]"
            @click="changeRoute(item.name, index)"
          >
            <v-list-tile-action>
              <v-icon :color="selectedIndex === index?'#114975':''">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-title :class="[{'activeMenu': selectedIndex === index}, 'item-title' ]">
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile>

          <v-list-group
            v-if="item.childrens!=null"
            prepend-icon="dashboard"
          >
            <v-list-tile slot="activator">
              <v-list-tile-title :class="[{'activeMenu': selectedIndex === index}, 'item-title' ]">
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-for="(children, i) in item.childrens"
              :key="i"
              @click="changeRoute(children.name)"
            >
              <v-list-tile-title v-text="children.title" />
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>
    </div>
    <page-footer style="position:fixed;bottom:0;right: 0; left:0px" />
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      toggle: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        selectedIndex: 0,
      }
    },
    watch:{
      '$route' (to, from) {
        let ind= this.menuItems.findIndex(x=>x.name==to.name);
        if(ind!=-1){
          this.selectedIndex=ind;
        }
      }
    },
    created(){
      this.$store.dispatch('userData/getMenuItems', );
    },
    mounted(){
      let curPage= this.$route.name;
      let ind= this.menuItems.findIndex(x=>x.name==curPage);
      if(ind!=-1){
        this.selectedIndex=ind;
      }
    },
    computed:{
      ...mapGetters({
        menuItemsForRole:"userData/getMenuItems",
        user:"userData/getUser"
      }),

      menuItems(){
        if (this.user != null) {
          return this.menuItemsForRole(this.user.profile.role);
        }
      },
      toggleVal:{
        get(){
          return this.toggle;
        },
        set(newValue){
          this.$emit("toggleNavigation",newValue)
        }
      }
    },
    methods: {
      changeRoute(routeName) {
        const vm = this;
        return vm.$router.push({ name: routeName });
      },
    }
  }
</script>

<style>
  .toolbar {
    font-weight: bold;
    font-size: 18px;
  }

  .toolbar .text {
    padding-left: 15px;
    color: white;
    text-decoration:none;
  }

  .item-title {
    font-size: 15px;
    font-weight: 300;
    color: #474f57;
  }
  .item-sub-title {
    font-size: 10px;
    font-weight: 300;
  }
  .activeBox{
    background-color: #eeeeee;
  }

  .activeMenu {
    font-size: 17px;
    font-weight: 700;
    color: #114975;
  }
</style>
